var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31047 4.81476L0.816041 1.32033L1.96303 0.17334L18.184 16.3943L17.037 17.5413L9.16406 9.66835H5.44477V8.04625H7.54196L5.91987 6.42416H4.63372C3.28994 6.42416 2.20058 7.51352 2.20058 8.8573C2.20058 10.2011 3.28994 11.2904 4.63372 11.2904H7.87791V12.9125H4.63372C2.39408 12.9125 0.578491 11.0969 0.578491 8.8573C0.578491 6.72646 2.22196 4.97948 4.31047 4.81476ZM16.4171 12.3565L15.2033 11.1427C16.1347 10.8014 16.7994 9.90698 16.7994 8.8573C16.7994 7.51352 15.7101 6.42416 14.3663 6.42416H11.1221V4.80207H14.3663C16.6059 4.80207 18.4215 6.61766 18.4215 8.8573C18.4215 10.3487 17.6164 11.6521 16.4171 12.3565Z",
    fill: "#02006E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevoke);
export default __webpack_public_path__ + "static/media/revoke.5ecd47500c6213561b32526f509a9afc.svg";
export { ForwardRef as ReactComponent };